import React from 'react';
import { Grid, Box, Button } from '@material-ui/core';
import somethingWentWrong from 'assets/svgs/something-went-wrong.svg';
import ResponsiveText from './ResponsiveText';
import { withStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
import PropTypes from 'prop-types';
import { SUPPORT, RELOAD, OK } from 'constants/constant';
import { getBaseUrl } from 'helper/utils';

const StyledButton = withStyles({
	root: {
		background: colors.PURPLE,
		borderRadius: '20px !important',
		height: 40,
		color: `${colors.WHITE}`,
		width: 90,
		fontSize: '14px',
		fontFamily: 'Bogle-Medium',
		textTransform: 'capitalize !important',
		'&:hover': {
			background: `${colors.LIGHT_PURPLE}`
		}
	}
})(Button);

const StyledSupportButton = withStyles({
	root: {
		lineHeight: '24px',
		fontFamily: 'Bogle-Medium',
		fontSize: '14px',
		color: `${colors.PURPLE}  !important`,
		borderRadius: '20px  !important',
		height: 40,
		width: '142px',
		'&:hover': {
			background: `${colors.LIGHT_PURPLE}  !important`,
			color: `${colors.WHITE}  !important`
		},
		border: '1px solid !important'
	}
})(Button);

const styledButton = (ok, reload, refreshPage, clearPreviewLoaded) => {
	return ok ? (
		<StyledButton id="reload" color="primary" variant="contained" onClick={clearPreviewLoaded}>
			{OK}
		</StyledButton>
	) : (
		<StyledButton id="reload" color="primary" variant="contained" onClick={reload || refreshPage}>
			{RELOAD}
		</StyledButton>
	);
};

function ErrorPage(props) {
	const {
		isSmallScreen,
		reload = null,
		errorMsg = undefined,
		ok = false,
		clearPreviewLoaded
	} = props;

	function refreshPage() {
		window.location.reload(false);
	}
	const baseURL = getBaseUrl();
	const button = styledButton(ok, reload, refreshPage, clearPreviewLoaded);
	return (
		<Grid container justifyContent="space-between">
			<Grid item xs={12} sm={12} md={12} lg={12} style={{ zIndex: 1 }}>
				<Box display="flex" justifyContent="center">
					<img
						style={{
							width: isSmallScreen ? '120px' : '150px',
							height: isSmallScreen ? '175px' : '140px'
						}}
						src={somethingWentWrong}
						alt="Something went wrong"></img>
				</Box>
				<Box display="flex" justifyContent="center" mt={2} mx={5}>
					{errorMsg ? (
						<ResponsiveText text={errorMsg} isSmallScreen={isSmallScreen} />
					) : (
						<ResponsiveText isSmallScreen={isSmallScreen} />
					)}
				</Box>
				<Box display="flex" justifyContent="center" alignItems="center" mt={2} p={6}>
					<div style={{ paddingRight: isSmallScreen ? '12px' : 40 }}>
						{ok ? null : (
							<StyledSupportButton href={`${baseURL}/support`}>{SUPPORT}</StyledSupportButton>
						)}
					</div>
					<div style={{ paddingLeft: isSmallScreen ? '12px' : 40 }}>{button}</div>
				</Box>
			</Grid>
		</Grid>
	);
}

ErrorPage.propTypes = {
	isSmallScreen: PropTypes.bool,
	reload: PropTypes.func
};

export default ErrorPage;
